import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  RequestTypes,
  registerMutationKeys,
  registersQueryKeys,
} from '@core/react-query/features/registers/registers'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useCreateProjectRegister = (
  options?: UseMutationOptions<
    any,
    RequestErrorType,
    RequestTypes['createProjectRegister']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...registerMutationKeys.createProjectRegister,
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(registersQueryKeys.registers._def)
    },
  })
}
